import { callApi } from "modules/core/api/services";
import { ApiResponse } from "modules/core/api/types";
import { Page } from "types/interfaces/Page";

export const getPage = (uuid: string, page: string) =>
  callApi<Page>(`/v2/regions/${uuid}/pages/${page}?locale=en`);
